import { referralsApi } from '@/lib/api/referrals';
import { QUERY_KEYS } from '@/lib';
import { useStanQuery } from '@/queries';
import type { ReferralsTableParams } from '../types/referrals.types';

/**
 * Query to fetch referrals table data with optional filters and pagination
 */
export function useReferrals(params: ReferralsTableParams = {}) {
    const { data, isLoading, isError, error, refetch } = useStanQuery(
        {
            queryKey: [QUERY_KEYS.REFERRALS, params],
            queryFn: () => referralsApi.getReferralsTable(params),
            staleTime: 5 * 60 * 1000, // 5 minutes
            meta: { error: { sentryMessage: '[REFERRALS] failed-to-fetch-referrals' } },
        },
        true
    );

    return {
        referrals: data?.data ?? [],
        metadata: data?.metadata,
        isLoading,
        isError,
        error,
        refetch,
    };
}

/**
 * Query to fetch referrals analytics data (chart and metrics)
 */
export function useReferralsAnalytics() {
    const { data, isLoading, isError, error, refetch } = useStanQuery(
        {
            queryKey: [QUERY_KEYS.REFERRALS_ANALYTICS],
            queryFn: () => referralsApi.getReferralsAnalytics(),
            staleTime: 5 * 60 * 1000, // 5 minutes
            meta: { error: { sentryMessage: '[REFERRALS] failed-to-fetch-referrals-analytics' } },
        },
        true
    );

    return {
        data,
        isLoading,
        isError,
        error,
        refetch,
    };
}
